const $ = require('jquery')

/**
 * Add loader
 */
$.fn.addLoader = function addLoader(dark) {
  this.removeLoader()
  const loader = $(`<div id="${this[0].id}_loader" class="loader block"></div>`)
  if (dark) {
    loader.addClass('dark')
  }
  this.append(loader)
  return this
}

/**
 * Remove loader gif
 */
$.fn.removeLoader = function removeLoader() {
  this.find(`#${this[0].id}_loader`).remove()
  return this
}
